import * as THREE from 'three';

const DEFAULT_PLANET_COLOR = 0x3b4350;

export function generatePlanetMesh({ texture = null, color = DEFAULT_PLANET_COLOR } = {}, scene) {
  const existingPlanet = scene.getObjectByName('planet');

  if (existingPlanet) {
    existingPlanet.material.map = texture;
    existingPlanet.material.color.set(texture ? 0xffffff : color);
    existingPlanet.material.needsUpdate = true;
    return existingPlanet;
  }

  const planetGeometry = new THREE.SphereGeometry(0.995, 128, 64);
  const planetMaterial = new THREE.MeshBasicMaterial({
    map: texture,
    color: texture ? 0xffffff : color,
  });

  const planetMesh = new THREE.Mesh(planetGeometry, planetMaterial);
  planetMesh.name = 'planet';
  scene.add(planetMesh);

  return planetMesh;
}
